<template>
  <div class="bg-gray-200 py-2 px-4 mt-4">
    <div class="h-12 flex items-center justify-between">
      <div class="text-lg font-semibold" :class="relativeNameClasses">{{ task.name }}</div>
      <a href="#" class="ml-8 btn btn-primary text-sm" @click.prevent="onStart" v-if="task.status === 'ready'">Start</a>
      <div class="text-red-500 block font-semibold text-sm" v-if="task.status === 'finished'" style="margin-top:3px">
        {{ task.date }}
      </div>
    </div>
    <div class="my-4" v-if="task.status === 'started'">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'workflow-task',
  props: {
    'task': {
      type: Object,
      required: true
    }
  },
  computed: {
    relativeNameClasses () {
      return {
        'text-gray-500': this.task.status === 'pending'
      }
    }
  },
  methods: {
    onStart () {
      this.$emit('start')
    }
  }
}
</script>